import { useTranslation } from '@shared/core';
import { Flex, ButtonV2 } from '@withjoy/joykit';
import React from 'react';
import { BackButton } from './BackButton';
import { useSignIn } from '../hooks/useSignIn';

type LogInProps = {
  eventHandle: string;
};

export const LogIn = (props: LogInProps) => {
  const { tq } = useTranslation('collaboration');
  const { signIn } = useSignIn();
  const { eventHandle } = props;

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      gap="1.5rem"
    >
      <ButtonV2
        intent="primary"
        shape="rounded"
        onClick={signIn}
      >{tq`Log In or Create Account`}</ButtonV2>
      <BackButton eventHandle={eventHandle} />
    </Flex>
  );
};
